export default __webpack_public_path__ + "static/media/p2.609495ce.jpg";